/**
 * Logical game size for the mobile edition, computed once at start from the device:
 * - height follows the physical pixel height (sharp rendering), clamped for performance
 * - width follows the aspect ratio, so the game fills the screen without black bars
 * Gameplay is resolution independent (world units), only the visible width differs.
 */
export function mobileGameSize(): { width: number; height: number } {
  const vw = window.visualViewport?.width ?? window.innerWidth;
  const vh = window.visualViewport?.height ?? window.innerHeight;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const height = Math.round(clamp(vh * dpr, 960, 1600));
  // portrait only: between 9:21 (tall phones) and 3:4 (tablets / desktop browser for testing)
  const aspect = clamp(vw / vh, 9 / 21, 3 / 4);
  return { width: Math.round(height * aspect), height };
}

function clamp(v: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, v));
}
